export enum BuildingTypeEnum {
  Residential_Domestic = 1,
  Commercial_Residential,
  Commercial_Basic,
  Commercial_Complex,
  Industrial,
  Offshore,
  Marine,
}
